import React from 'react'

export default ({
    children,
    className,
    ...props
}) => {
    const prefix = 'vrtl-mapped-template'
    return (
        <div className={`${prefix}__heading-container ${prefix}__heading-margin`}>
            <div className={`${prefix}__section--3`}>Name</div>
            <div className={`${prefix}__icon-offset`} />
            <div className={`${prefix}__icon-offset`} />
            {
                children
                    ? React.cloneElement(children, { ...props, className: `${prefix}__icon-add` })
                    : <div className={`${prefix}__icon-offset`} />
            }
        </div>
    )
}
